import React, { useRef } from 'react';
import { FieldRadioButton } from '../../../components';
import {
    HORSE_AVAILABILITY_PART_TIME_OPTION_UNLIMITED,
    HORSE_AVAILABILITY_PART_TIME_OPTION_FROM_SPEC_DAY,
    HORSE_AVAILABILITY_PART_TIME_OPTION_RANGE,
} from '../../../marketplace-custom-config';
import { FormattedMessage } from '../../../util/reactIntl';
import { required } from '../../../util/validators';
import css from '../EditListingDescriptionForm.css';
import { useIntl } from 'react-intl';
import { usePrefilledValue } from '../../../components/EditListingWizard/hooks/usePrefilledValue';
import EditListingDescriptionPageTwoDates from './EditListingDescriptionPageTwoDates';
import { PrefilledValueTooltip } from '../../../components/EditListingWizard/Components/PrefilledValueTooltip/PrefilledValueTooltip';
import { getPrefilledValueFromHorseType } from '../../../components/EditListingWizard/Helpers';
import { EDIT_LISTING_TAB_START_DATE } from '../../../components/EditListingWizard/config';

const fieldName = 'openForPartTimeProposals';

const EditListingDescriptionPageTwo = ({ form, values }) => {
    const intl = useIntl();
    const containerRef = useRef();
    const { openForPartTimeProposals } = values;

    const prefilledValue =
        getPrefilledValueFromHorseType({
            tab: EDIT_LISTING_TAB_START_DATE,
            values,
        }) || HORSE_AVAILABILITY_PART_TIME_OPTION_UNLIMITED;

    const { showPrefilledValue } = usePrefilledValue({
        form,
        fieldName,
        prefilledValue,
    });

    const selectedValueAbDatum =
        openForPartTimeProposals === HORSE_AVAILABILITY_PART_TIME_OPTION_FROM_SPEC_DAY;
    const selectedValueBefristet =
        openForPartTimeProposals === HORSE_AVAILABILITY_PART_TIME_OPTION_RANGE;

    return (
        <div>
            <h1 className={css.horseTypeTitle}>
                <FormattedMessage id="EditListingDescriptionForm.startDateTitle" />
            </h1>
            <p className={css.horseTypeSubTitle}>
                <FormattedMessage id="EditListingDescriptionForm.startDateSubTitle" />
            </p>

            <div ref={containerRef}>
                {[
                    HORSE_AVAILABILITY_PART_TIME_OPTION_UNLIMITED,
                    HORSE_AVAILABILITY_PART_TIME_OPTION_FROM_SPEC_DAY,
                    HORSE_AVAILABILITY_PART_TIME_OPTION_RANGE,
                ].map(id => {
                    const isPrefilledValue = showPrefilledValue && id === prefilledValue;

                    return (
                        <FieldRadioButton
                            key={id}
                            id={id}
                            value={id}
                            form={form}
                            name={fieldName}
                            label={intl.formatMessage({
                                id: `EditListingDescriptionForm.startDateRadioButton-${id}`,
                            })}
                            validate={required('Dieses Feld wird benötigt')}
                        >
                            {isPrefilledValue && (
                                <PrefilledValueTooltip parentContainerRef={containerRef} />
                            )}
                        </FieldRadioButton>
                    );
                })}
            </div>

            {selectedValueAbDatum || selectedValueBefristet ? (
                <EditListingDescriptionPageTwoDates
                    form={form}
                    showEndDate={Boolean(selectedValueBefristet)}
                />
            ) : null}
        </div>
    );
};

export default EditListingDescriptionPageTwo;
